module.exports = __webpack_public_path__ + "static/smurgle-b44168750944b02fa4ec82732f15363a.svg";